export default __webpack_public_path__ + "static/media/expression-incorrect.6d0e0dc8.PNG";